////////特殊規則大眾運輸 暫時訂為level 10 key massTransit
const threeFiveSchema = {
  title: "3_5 Business Travel",
  addAPI: "cat3_5AddEmissionActivityAPI",
  cat: "cat3_5",
  category: "3_5",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Staff Name / No",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Transportation",
      optionsAPI: "businessTravelTransportationMethodAPI",
      resetOnChange: true,
      required: true,
    },
    ////////計算方法
    {
      key: "calculationId",
      level: 2,
      type: "select",
      label: "Calculation Method",
      optionsParamFrom: { value: "3_5" },
      optionsAPI: "cat3Calculation",
      resetOnChange: true,
      required: true,
      cascadeClear: true,
    },
    ////////計算方法名稱
    {
      key: "calculationName",
      level: "calculationName",
      label: "Calculation Method",
    },
    //////// Passenger Distance Based且不為大眾運輸
    // {
    //   key: "origin",
    //   level: 2,
    //   type: "input",
    //   label: "Origin",
    //   showIf: {
    //     all: [
    //       { level: 1, key: "activityId", notEmpty: true },
    //       { level: 2, key: "calculationId", eq: 4 },
    //       { level: 10, key: "isMassTransit", ne: 1 },
    //     ],
    //   },
    // },
    // {
    //   key: "destination",
    //   level: 2,
    //   type: "input",
    //   label: "Destination",
    //   showIf: {
    //     all: [
    //       { level: 1, key: "activityId", notEmpty: true },
    //       { level: 2, key: "calculationId", eq: 4 },
    //       { level: 10, key: "isMassTransit", ne: 1 },
    //     ],
    //   },
    // },
    // {
    //   key: "distance",
    //   level: 2,
    //   type: "input",
    //   label: "Distance (Unit: km)",
    //   showIf: {
    //     all: [
    //       { level: 1, key: "activityId", notEmpty: true },
    //       { level: 2, key: "calculationId", eq: 4 },
    //       { level: 10, key: "isMassTransit", ne: 1 },
    //     ],
    //   },
    //   required: true,
    //   placeholder: 0,
    // },
    //////// Passenger Distance Based且為大眾運輸
    // {
    //   key: "origin",
    //   level: 2,
    //   type: "input",
    //   label: "Departure Station",
    //   showIf: {
    //     all: [
    //       { level: 1, key: "activityId", notEmpty: true },
    //       { level: 2, key: "calculationId", eq: 4 },
    //       { level: 10, key: "isMassTransit", eq: 1 },
    //     ],
    //   },
    // },
    // {
    //   key: "destination",
    //   level: 2,
    //   type: "input",
    //   label: "Destination Station",
    //   showIf: {
    //     all: [
    //       { level: 1, key: "activityId", notEmpty: true },
    //       { level: 2, key: "calculationId", eq: 4 },
    //       { level: 10, key: "isMassTransit", eq: 1 },
    //     ],
    //   },
    // },
    // {
    //   key: "distance",
    //   level: 2,
    //   type: "input",
    //   label: "Distance (Unit: km)",
    //   showIf: {
    //     all: [
    //       { level: 1, key: "activityId", notEmpty: true },
    //       { level: 2, key: "calculationId", eq: 4 },
    //       { level: 10, key: "isMassTransit", eq: 1 },
    //     ],
    //   },
    //   required: true,
    //   placeholder: 0,
    // },
  ],
};

export default threeFiveSchema;
